import { customerEndpoints } from "./endpoints";
import LocationClient from "./LocationClient";

class CustomerLocationClient extends LocationClient {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient; // The apiClient instance is injected here
  }

  async getLocation(nested) {
    return this.apiClient.get(customerEndpoints.location, { nested });
  }

  async getWallboxes(nested) {
    return this.apiClient.get(customerEndpoints.wallbox, { nested });
  }

  async getWallbox(id, nested) {
    return this.apiClient.get(customerEndpoints.wallbox + id, { nested });
  }

  async putWallbox(id, data) {
    return this.apiClient.put(customerEndpoints.wallbox + id, data);
  }

  async putWallboxSetPoint(id, data) {
    return this.apiClient.put(customerEndpoints.wallboxsetpoint + id, data);
  }

  async addWallboxLockTime(data) {
    return this.apiClient.post(customerEndpoints.wallboxlocktime, data);
  }

  async deleteWallboxLockTime(id) {
    return this.apiClient.delete(customerEndpoints.wallboxlocktime + id);
  }

  async getHeatpumps(nested) {
    return this.apiClient.get(customerEndpoints.heatpump, { nested });
  }

  async putHeatpump(id, data) {
    return this.apiClient.put(customerEndpoints.heatpump + id, data);
  }

  async putHeatpumpSetPoint(id, data) {
    return this.apiClient.put(customerEndpoints.heatpumpsetpoint + id, data);
  }

  async getFlow() {
    return this.apiClient.get(customerEndpoints.flow);
  }

  async getSgReadyHistory(params = {}) {
    return this.apiClient.get(customerEndpoints.heatpumpsgreadyhistory, params);
  }

  async getChargingHistory(params = {}) {
    return this.apiClient.get(customerEndpoints.wallboxcharginghistory, params);
  }

  async getChargingHistoryStats(params = {}) {
    return this.apiClient.get(customerEndpoints.wallboxcharginghistorystats, {
      ...params,
    });
  }

  async getHourlyFlow(params = {}) {
    return this.apiClient.get(customerEndpoints.hourlyflow, params);
  }

  async getDailyFlow(params = {}) {
    return this.apiClient.get(customerEndpoints.dailyflow, params);
  }

  async getMonthlyFlow(params = {}) {
    return this.apiClient.get(customerEndpoints.monthlyflow, params);
  }
}

export default CustomerLocationClient;
